export const configs = {
  auth0_domain: 'auth.tenantport.com',
  auth0_clientId: 'gno3Hpfp8Qo9knf5PziyCJJ0LFdtk6t4',
  api_audience: 'http://resident-portal-API',
  baseUrl:
    process.env.REACT_APP_ENV === 'prod'
      ? 'https://api.tenantport.com'
      : process.env.REACT_APP_ENV === 'qa'
        ? 'https://api.qa.tenantport.com'
        : 'http://localhost:8080',
};
